import { useEffect } from "react";
import { hotjar } from 'react-hotjar'

export default function Hotjar() {
    useEffect(() => {
        hotjar.initialize(3026151, 6)
    }, [])

    return null;
}